import { DynamicStandaloneButtonWith } from '@/components/Button';
import { useClassName, useTheme } from '@/styles/Banner';
import { GenericComponentFactory } from 'base/components/GenericComponent';

const Button = DynamicStandaloneButtonWith({ theme: { useTheme } });

const GenericComponent = GenericComponentFactory({ useClassName });

const Section = GenericComponent({ as: 'section' });
const Headline = GenericComponent({ as: 'h3', styles: { key: 'headline' } });
const Description = GenericComponent({ as: 'p', styles: { key: 'description' } });
const Image = GenericComponent({ as: 'picture', styles: { key: 'image' } });

export const Banner = Object.assign(Section, {
  Headline,
  Description,
  Button,
  Image,
});
